<template>
	<div class="custom-tooltip" v-if="isHeader">
		<p>Group Name: {{ params.value }}</p>
		<hr v-if="isGroupedHeader" />
		<div v-if="isGroupedHeader">
			<p v-for="(header, idx) in params.colDef.children" :key="idx">
				Child {{ idx + 1 }} - {{ header.headerName }}
			</p>
		</div>
	</div>
	<div class="custom-tooltip" v-else>
		<p><span>isPickup's Name:</span></p>
		<p>
			<span>{{ isPickup }}</span>
		</p>
	</div>
</template>
<script>
export default {
	name: "CellRenderCustomTooltip",
	data() {
		return {
			isPickup: null,
		};
	},
	beforeMount() {
		const params = this.params;
		this.isPickup = params.value.value ? params.value.value : "- Missing -";
		this.isHeader = params.rowIndex === undefined;
		this.isGroupedHeader = !!params.colDef.children;
	},
};
</script>
